module.exports = __webpack_public_path__ + "static/media/banner-img-wrp-img-4.907333c8.png";